export default {
	'add-journal': 'Agregar diario',
	post: 'publicar',
	unpost: 'despublicar',
	posted: 'Publicado',
	unposted: 'No publicado',
	'preview-receiving': 'Vista previa de la recepción',
	'preview-delivery': 'Vista previa de la entrega',
	'the-journal': 'El diario?',
	'preview-order-results': 'Vista previa de los resultados del pedido',
	'preview-production-order': 'Vista previa de orden de producción',
}